import React from "react";
import styles from './ProductAutoComplete.module.scss';
import { useFetchProductsByName } from '../common/actions/products';
import Tooltip from '@material-ui/core/Tooltip';
import Select, { components } from 'react-select';
import { isEmpty } from 'lodash';
import { useDebounce } from 'use-debounce';



export default function ProductPicker({ onChangeProductId, selectedProduct }) {
    const [searchTerm, setSearchTerm] = React.useState('');
    const [debouncedSearchTerm] = useDebounce(searchTerm, 500);
    const {data : productList = []} = useFetchProductsByName(debouncedSearchTerm);
    const [selectOptions, setSelectOptions] = React.useState([]);
    const [selectedValue, setSelectedValue] = React.useState(null);

    React.useEffect(() => {
        const product = selectedProduct;
        // Clear, rather than keep showing the previously selected route's product.
        if (isEmpty(product)) {
            setSelectedValue(null);
            return;
        }
        const value = selectValueFromProduct(product);
        setSelectedValue(value);
    }, [selectedProduct])


    React.useEffect(() => {
        // Just load top 100. Otherwise, it slows down the laoding of items.
        const maxCount = 100;
        setSelectOptions(productList?.slice(0, maxCount).map(selectValueFromProduct));
    }, [productList])

    const onPickerChange = (selectedOption) => {
        const productId = selectedOption.value;
        onChangeProductId(productId);
    }

    const onInputChange = (inputValue) => {
        setSearchTerm(inputValue);
    }


    return (
        <div className={styles.productAutoComplete}>
          <div className={styles.productAutoCompleteMain}>
            <span>Product Name</span>
            <Select
              className={styles.productSelect}
              inputId="react-select-single"
              TextFieldProps={{
                label: 'Product Name 2',
                InputLabelProps: {
                  htmlFor: 'react-select-single',
                  shrink: true,
                },
                placeholder: 'Select ProductId',
              }}
              options={selectOptions}
              // For more study: https://react-select.com/components#replaceable-components
              components={{ Option: renderOptionWithToolTip }}
              value={selectedValue}
              onChange={onPickerChange}
              onInputChange={onInputChange}
            />
          </div>
        </div>

    )
}


function renderOptionWithToolTip(props) {
    if (isEmpty(props.data)) return null;

    let Option = (
      <Tooltip title={props.data.toolTip || ''}>
        <div>
          <components.Option {...props} />
        </div>
      </Tooltip>
    );
    return Option;
  }


function selectValueFromProduct(product) {
    // content-api's browse list carries id/name/type/category/isEnabled; a product
    // already stored on the route carries its productCities instead.
    const parts = [product.id, product.category, product?.productCities?.[0]?.city].filter(Boolean);
    if (product.isEnabled === false) parts.push('not enabled');

    return {
      label: product.name,
      value: product.id,
      toolTip: `${product.name} (${parts.join(' · ')})`,
    };
}
